import SimpleSlotView from 'assembly/views/SimpleSlotView';

class GibsonSlotView extends SimpleSlotView {}

export default GibsonSlotView;
